import { getFirebasePublicConfig } from './config';
import { isAnalyticsConsentGranted } from './consent';

type PerformanceEnablementInput = {
  nodeEnvironment?: string;
  platformEnvironment?: string;
  origin?: string;
  hasCompleteConfig: boolean;
  consentGranted: boolean;
  disabled: boolean;
};

export const shouldEnableFirebasePerformance = ({
  nodeEnvironment,
  platformEnvironment,
  origin,
  hasCompleteConfig,
  consentGranted,
  disabled,
}: PerformanceEnablementInput): boolean =>
  nodeEnvironment === 'production' &&
  platformEnvironment?.trim().toUpperCase() === 'PROD' &&
  origin === 'https://developer.bundledrop.app' &&
  hasCompleteConfig &&
  consentGranted &&
  !disabled;

export const isFirebasePerformanceEnabled = (): boolean =>
  typeof window !== 'undefined' &&
  shouldEnableFirebasePerformance({
    nodeEnvironment: process.env.NODE_ENV,
    platformEnvironment: process.env.ENV_NAME || process.env.REACT_APP_ENV_NAME,
    origin: window.location.origin,
    hasCompleteConfig: getFirebasePublicConfig() !== null,
    consentGranted: isAnalyticsConsentGranted(),
    disabled: process.env.REACT_APP_PERFORMANCE_ENABLED === 'false',
  });

export const getPerformanceReleaseAttributes = (): Record<string, string> => {
  const release = process.env.REACT_APP_RELEASE_SHA || '';
  return /^[a-f0-9]{7,40}$/i.test(release) ? { release: release.toLowerCase() } : {};
};
